import React, { FC, useEffect, useState } from "react";
import classes from "./Login.module.scss";
import logo from "../../../assets/logo.png";
import google from "../../../assets/google.png";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loadingState, loadingText } from "../../../states/loadingState";
import { Header } from "../../layout/header/Header";
import Footer from "../../layout/header/Footer";
import { theme } from "../../../theme/theme";
import { userState } from "../../../states/userState";
import SwitchMode from "../../uikit/atoms/SwitchMode";
import { ErrorModal } from "../../uikit/atoms/modal/ErrorModal";
import { useLogin } from "../../../hooks/useLogin";

const Login: FC = () => {
  const navigation = useNavigate();

  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("ログインエラー");
  const [isHovered, setIsHovered] = useState(false);
  const [message, setMessage] = useState("Google認証に失敗しました");
  const [isShowErrorDialog, setIsShowErrorDialog] = useState(false);
  const [user, setUser] = useRecoilState(userState);
  const { loginWithGoogle, error } = useLogin();
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  const onClickLogin = async () => {
    //ローディング表示
    //画面
    setLoadingAnimation(true);
    setLoadingText("認証中...");
    //ボタン
    setLoading(true);
    try {
      await loginWithGoogle();
      navigation("/");
    } catch (error) {
      //モーダル表示
      setMessage("Google認証に失敗しました");
      setIsShowErrorDialog(true);
    } finally {
      setLoading(false);
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };
  // useEffect(() => {
  //   console.log("isHovered", isHovered);
  // }, [isHovered]);
  useEffect(() => {
    if (user?.isAuth) {
      navigation("/");
    }
  }, [navigation, user]);
  const ImageIcon = () => {
    return (
      <img
        src={google}
        alt="Login"
        style={{ width: 32, height: 24, paddingRight: 10 }}
      />
    );
  };

  return (
    <div className={classes.wrapper} style={color(user?.mode ?? "lite")}>
      <div className={isHovered ? classes.visible : classes.header}>
        <Header pageTitle={""} />
      </div>
      <div className={classes.root}>
        {/* <Tilt options={defaultOptions}> */}
        <div
          className={classes.card}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className={classes.content}>
            <div className={classes.switch}>
              <SwitchMode />
            </div>
            <h3 className={classes.title}>End MaRK</h3>
            <div className={classes.loginLogo}>
              <img src={logo} alt="" />
            </div>
            {/* <a href="#">More Detail</a> */}
            <LoadingButton
              onClick={onClickLogin}
              loadingPosition="start"
              startIcon={<ImageIcon />}
              loading={loading}
              variant="contained"
              sx={{ boxShadow: "0 5px 15px rgba(0, 0, 0, 0.5)" }}
            >
              ログイン
            </LoadingButton>
          </div>
        </div>

        {/* </Tilt> */}
      </div>
      <div className={isHovered ? classes.visible : classes.footer}>
        <Footer />
      </div>
      {isShowErrorDialog && (
        <ErrorModal
          title={title}
          message={message}
          setIsShow={setIsShowErrorDialog}
        />
      )}
    </div>
  );
};
const color = (mode: string) => {
  return {
    background:
      mode === "lite"
        ? theme.palette.liteColor.backColor.main
        : theme.palette.darkColor.backColor.main,
  };
};
export default Login;
